import styled from 'styled-components';

export const FlexContainer = styled.div`
    display: flex;
    max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : 'none')};
    flex-direction: ${({ direction }) => direction || 'row'};
    justify-content: ${({ justify }) => justify || 'flex-start'};
    align-items: ${({ align }) => align || 'center'};
    flex-wrap: ${({ wrap }) => wrap || 'nowrap'};
    gap: ${({ gap }) => (typeof gap === 'number' ? `${gap}px` : gap || '0')};
    width: ${({ width }) => (typeof width === 'number' ? `${width}px` : width || 'auto')};
    height: ${({ height }) => (typeof height === 'number' ? `${height}px` : height || 'auto')};
    padding: ${({ padding }) => (typeof padding === 'number' ? `${padding}px` : padding || '0')};
    margin: ${({ margin }) => (typeof margin === 'number' ? `${margin}px` : margin || '0')};
    position: ${({ position }) => position || 'static'};

    @media (max-width: 768px) {
        flex-direction: ${({ mobileDirection, direction }) => mobileDirection || direction || 'column'};
        justify-content: ${({ mobileJustify, justify }) => mobileJustify || justify || 'flex-start'};
        display: ${({ hideOnMobile }) => (hideOnMobile ? 'none' : 'flex')};
        align-items: ${({ mobileAlign, align }) => mobileAlign || align || 'center'};
        gap: ${({ mobileGap, gap }) => typeof mobileGap === 'number'? `${mobileGap}px`
                : typeof gap === 'number'
                ? `${gap}px`
                : gap || '0'
        };
        }
    
    @media (max-width: 1024px) and (min-width: 769px) {
        flex-wrap: wrap;
        justify-content: center;
    }
    /* @media ((min-width: 768px) and (max-width: 1114px)) {
        flex-direction: ${({ tabletDirection, direction }) => tabletDirection || direction || 'column'};
    } */
`;

export const FlexColumn = styled.div`
    display: flex;
    flex-direction: ${({ direction }) => direction || 'row'};
`